import { Edit, SimpleForm } from 'react-admin';
import { MyFormContainer, MyToolbar } from '@/components/forms';
import { PlanFormFields } from './PlanForm';

export const PlanEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm toolbar={<MyToolbar resource="plans" />}>
      <MyFormContainer>
        <PlanFormFields isCreate={false} />
      </MyFormContainer>
    </SimpleForm>
  </Edit>
);

export default PlanEdit;
